import { Component } from '@angular/core';
import { AuthService } from '../_services/auth.service'







@Component({
  selector: 'app-maptracker',
  templateUrl: './maptracker.component.html',
  styleUrls: ['./maptracker.component.css'],
})
// export class MaptrackerComponent {
   

// }


export class MaptrackerComponent {
  userName: any;
  isMCG: boolean;
  isSuperAdmin: boolean;
  prjID: any;
  isFBD: boolean;
  constructor(
    private auth : AuthService
   ) { }

  ngOnInit() {
    this.userName = this.auth.getAuthentication().userName;
    this.prjID = this.auth.getAuthentication().projectId;
    var authData = JSON.parse(localStorage.getItem('authData'))
    

   // old
    // if(authData.id == 445){
    //   this.isSuperAdmin = false


    //   console.log('this.isSuperAdmin',this.isSuperAdmin);
      
    // }
    // else {
    //   this.isSuperAdmin = true
    //   console.log('this.isSuperAdmin',this.isSuperAdmin);
    // }


   //new
    // if(authData.id == 19){
    //   this.isSuperAdmin = true


    //   console.log('this.isSuperAdmin',this.isSuperAdmin);
      
    // }
    // else {
    //   this.isSuperAdmin = false
    //   console.log('this.isSuperAdmin',this.isSuperAdmin);
    // }

    this.isFBD = this.prjID == 3 ? true : false;
    
    if(this.userName.includes('ASI_')){
      if($( window ).width() <= 600){
        $( ".main-content" ).addClass('mcgClass');
        // $( ".sub-nav-menu,.sub-nav h4" ).css({'display':'none'});
        $( ".sub-nav" ).hide();
      }
      else{
        $( ".main-content" ).removeClass('mcgClass');
        $( ".sub-nav" ).show();
      }
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/maptracker/maptracker.component.ts